<template>
  <div class="input__file">
    <div class="input__default">
      <label :for="id">
        <slot></slot>
      </label>
      <input :id="id" ref="input" type="file" @change="processFile($event)" :accept="accept" v-bind="$attrs">
    </div>
    <div class="file__details">
      <div v-if="b2FileData !== null">
        Uploadé le {{ uploadedAt }}<br>Taille : {{ size }}
      </div>
    </div>
    <SkeletonDiv v-if="loadingPreview" :height="50" style="width:50px;" class="file__preview"/>
    <div v-if="!loadingPreview && filePreviewUrl.length > 0" class="file__preview">
      <a v-if="!filePreviewUrl.toLowerCase().includes('.pdf')" :href="filePreviewUrl" target="_blank">
        <div :style="`background-image:url('${filePreviewUrl}')`"></div>
      </a>
      <div v-else>
        <a class="file__pdflink" :href="filePreviewUrl" target="_blank">PDF
          <OpenInNew :size="14"/>
        </a>
      </div>
    </div>
    <div v-if="scanning" class="file__scanning">
      <Radiation class="spinning"/>
      Analyse antivirus en cours...
    </div>
  </div>
</template>

<script>
import OpenInNew from "@/components/icons/OpenInNew";
import imageCompression from 'browser-image-compression';
import SkeletonDiv from "@/components/skeletons/SkeletonDiv";
import Radiation from "@/components/icons/Radiation.vue";

export default {
  name: "InputFile",
  components: {SkeletonDiv, OpenInNew, Radiation},
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    b2FileData: {
      type: Object,
      default: null,
    },
    accept: {
      type: String,
      default: "image/*,.pdf",
    },
    sizeLimit: {
      type: Number,
      default: 10,
    },
    scaniiToken: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      file: '',
      filePreviewUrl: '',
      loadingPreview: false,
      scanning: false,
    }
  },
  computed: {
    size() {
      const size = this.b2FileData.contentLength
      if (size < 100000) {
        return `${Math.round(size / 1000)} KB`
      }
      return `${(size / 1000000).toFixed(2)} MB`
    },
    uploadedAt() {
      const date = new Date(this.b2FileData.uploadTimestamp)
      return date.toLocaleDateString()
    },
  },
  watch: {
    b2FileData: {
      handler(val, oldVal) {
        // Reset input field (when a file was uploaded and the server returns its data)
        if (oldVal === null && val instanceof Object) {
          this.$refs.input.value = ''
          this.file = ''
        }
        // Trigger preview
        this.filePreview()
      },
      deep: true
    },
  },
  methods: {
    async processFile(event) {
      // check the file size in MB
      const file = event.target.files[0]
      const size = (file.size / 1000000).toFixed(2)
      if (size > this.sizeLimit) {
        alert(`La taille du fichier dépasse la limite autorisée de ${this.sizeLimit}MB.`)
        this.$refs.input.value = ''
        return
      }
      let options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }
      await imageCompression(file, options)
        .then(compressedFile => {
          // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
          this.file = new File([compressedFile], compressedFile.name, {type: compressedFile.type})
        })
        .catch(error => {
          console.log(error.message)
          this.file = file
        })
      this.$emit('file-ready', {file: this.file, id: this.id})
    },
    filePreview() {
      this.loadingPreview = true
      this.$api.get(`g2r/v1/files/b2/shopFiles/0`, {
        params: {
          b2: this.b2FileData.fileName,
          b2_action: 'link',
        }
      }).then(response => response.data)
        .then(data => this.filePreviewUrl = data)
        .finally(() => this.loadingPreview = false)
    },
  },
  mounted() {
    if (undefined !== this.b2FileData && null !== this.b2FileData) {
      this.filePreview()
    }
  },
}
</script>

<style scoped lang="scss">
.input__file {
  background-color: whitesmoke;
  padding: .5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  align-items: center;
  //margin-bottom: 1rem;

  [type="file"] {
    border: none;
    background-color: transparent;
    padding: 0;
  }

  .file__details {
    font-size: 90%;
  }

  .link__preview {
    margin-top: 0.85rem;
  }

  .file__preview {
    justify-self: right;

    a {
      div {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .file__pdflink {
      display: flex;
      align-items: center;

      svg {
        margin-left: .25rem;
      }
    }

  }
}

.file__scanning {
  display: flex;
  align-items: center;
  font-style: italic;

  svg {
    margin-right: 1rem;
  }
}

@media screen and (max-width: 666px) {
  .input__file {
    .input__default {
      grid-column: span 2;
    }
  }
}

@media screen and (min-width: 667px) {
  .input__file {
    grid-template-columns: minmax(250px, 1fr) 1fr 1fr;
  }
}

</style>
